import React, { useEffect, useRef, useState } from 'react'
import {
    PiCaretDownFill,
    PiCaretUpFill,
    PiCheckCircleFill,
    PiWarningFill,
} from "react-icons/pi";
import { batchUploadFileAllNewMandates, checkExportTransactionHistory, checkExportTransactionHistoryOld, debittingCountApi, faAppReport, getAllNewMandates, getAllNewMandatesTransactions, getAllWorkflowMandates, getTransactionHistoryNew, getTransactionHistoryNewExport, getTransactionHistoryOld, getTransactionHistoryOldExport, mailReportApi, mailworkFlowReportApi, searchAllNewMandates, singleDebitApi, smsworkFlowReportApi, workFlowReportApi } from '../services';
import moment from 'moment';
import { useParams } from 'react-router';
import ReactPaginate from 'react-paginate';
import LoadingModal from '../components/modals/LoadingModal';
import { HiOutlineDotsVertical } from 'react-icons/hi';
import { ModalSingleDebit } from '../components/modals/ModalSingleDebit';
import { notify } from '../components/actions/CommonActions';
import { Button, Form, Row, Col, InputGroup, Table } from "react-bootstrap";
import { FiRefreshCcw } from 'react-icons/fi';
import { TransactionHistory } from '../components/modals/TransactionHistory';
import { AllNewTransactionModal } from '../components/modals/AllNewmandateTransactionModal';
import { GoDownload, GoStop } from 'react-icons/go';

const TransactionHistoryOld = () => {
    const [allMandates, setAllMandates] = useState([])
    const [loading, setLoading] = useState(false)
    const { mandateId, workflowId } = useParams()
    const [pageCount, setPageCount] = useState(0); // For total pages
    const [currentPage, setCurrentPage] = useState(1); // Current page
    const [limit, setLimit] = useState(10)
    const [selectedDetails, setSelectedDetails] = useState(null)
    const [search, setSearch] = useState("")
    const [isLoading, setIsLoading] = useState(false);
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [batchId, setBatchId] = useState(null)
    const dropdownRef = useRef(null);
    const [showSingleDebitModal, setShowSingleDebitModal] = useState(false)
    const [loadDebitting, setLoadDebitting] = useState(false)
    const [isUploadFile, setIsUploadFile] = useState(false);
    const [uploadedFile, setUploadedFile] = useState(null)
    const [history, setHistory] = useState();
    const [mandateInfo, setMandateInfo] = useState(null)
    const [resumption, setIsResumption] = useState(0);
    const [note, setNote] = useState("");
    const [status, setStatus] = useState('')
    const formatDate = (date) => date.toISOString().split("T")[0];

const [startDate, setStartDate] = useState(formatDate(new Date()));
const [endDate, setEndDate] = useState(formatDate(new Date()));

    const [stateTransact, setStateTransact] = React.useState({
        right: false,
    });
    const anchor = "right";
    const toggleDrawerTransact = (anchor, open, details) => (event) => {
        setSelectedDetails(details)
        // console.log('transact ', anchor, open);
        if (
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }

        setStateTransact({ ...stateTransact, [anchor]: open });
    }

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpenDropdownId(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const WORKFLOWSTATUS = {
        BILLER_INITIATED: 1,
        BILLER_AUTHORISED: 2,
        BILLER_REJECTED: 3,
        BILLER_APPROVED: 4,
        BANK_AUTHORIZED: 6,
        BANK_REJECTED: 7,
        BANK_APPROVED: 8,
        BANK_DISAPPROVED: 9,
    };

    function getWorkflowStatusLabel(statusCode) {
        const entry = Object.entries(WORKFLOWSTATUS).find(
            ([_, value]) => value === statusCode
        );

        if (!entry) return "Unknown Status";

        // Convert key to readable format e.g., BILLER_INITIATED => Biller Initiated
        const formatted = entry[0]
            .toLowerCase()
            .split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');

        return formatted;
    }


    const numberFormat = (value, toFixed = 2) => {
        const num = Number(value);
        if (Number.isInteger(num)) {
            return num.toLocaleString(); // Handles integer values without decimals
        } else {
            return num
                .toFixed(toFixed) // Ensures the specified number of decimal places
                .replace(/\d(?=(\d{3})+\.)/g, "$&,"); // Adds commas for thousands
        }
    };

    const handleAllMandates = async (page, limit) => {
        const params = {
            status: status,
            limit: limit,
            page: page,
            startDate: startDate,
            endDate: endDate
        }

        const searchParams = new URLSearchParams()
        // Add parameters only if they are defined and not empty
        Object.entries(params).forEach(([key, value]) => {
            if (value) {
                searchParams.append(key, value);
            }
        });

        await getTransactionHistoryOld(searchParams)
            .then((res) => {
                //   console.log("all mandates res ", res?.data?.data);
                setAllMandates(res?.data?.data)
                setPageCount(res?.data?.totalPages)
                // setFaReport(res?.data)
            })
            .catch((err) => {
                console.log('err ', err);
            })
    }

    const handleExportHistory = async (page, limit) => {
  const params = {
    status,
    limit,
    page,
    startDate,
    endDate,
    export: true,
  };

  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      searchParams.append(key, value);
    }
  });

  try {
    await getTransactionHistoryOldExport(searchParams);
  } catch (err) {
    console.log('Export error:', err);
  }
};



    const handlePageClick = async (data) => {
        setIsLoading(true);
        let selectedPage = data.selected + 1; // react-paginate uses 0-based index, so add 1
        setCurrentPage(selectedPage); // Update current page state
        await handleAllMandates(selectedPage, limit)
        setIsLoading(false);
    };


    const initiateNew = async (page, limit) =>{
                const params = {
                status: status,
                limit: limit,
                page: page,
            }
    
            const searchParams = new URLSearchParams()
            // Add parameters only if they are defined and not empty
            Object.entries(params).forEach(([key, value]) => {
                if (value) {
                    searchParams.append(key, value);
                }
            });
            
    
            await getTransactionHistoryOld(searchParams)
                .then((res) => {
                    //   console.log("all mandates res ", res?.data?.data);
                    setAllMandates(res?.data?.data)
                    setPageCount(res?.data?.totalPages)
                    // setFaReport(res?.data)
                })
                .catch((err) => {
                    console.log('err ', err);
                })
            }
    
        useEffect(() => {
            const initiate = async () => {
                setLoading(true)
                await initiateNew(1, 30)
                setLoading(false)
            }
            initiate()
        }, [])

    const toggleDropdown = (id, mandateCode, mandate) => {
        setOpenDropdownId(id);
        setBatchId(mandateCode)
        setMandateInfo(mandate)
    };

    const handleSingleDebit = async (count, reason, mandate) => {
        const sentData = {
            mandateId: `${batchId}`,
            count: count,
            reason: reason,
        }
        // console.log("sent data ", sentData);

        setLoadDebitting(true)
        await singleDebitApi(sentData)
            .then(async (res) => {
                //   console.log("all mandates res ", res?.data?.data);
                setLoadDebitting(false)
                setIsResumption("")
                setNote("")
                notify("success", "Mandate debitted successfully.", `${res?.message}`);
                setShowSingleDebitModal(false)
                await handleTransaction(mandateInfo)
                // setFaReport(res?.data)
            })
            .catch(async (err) => {
                setLoadDebitting(false)
                setShowSingleDebitModal(false)
                await handleTransaction(mandateInfo)
                notify("danger", "OOPS", `${err?.response?.data?.message}`);
                console.log('err ', err);
            })
    }

    const handleTransaction = async (mandate) => {
        setIsLoading(true)
        await getAllNewMandatesTransactions(mandate?.contractId)
            .then(async (res) => {
                //   console.log("all transaction res ", res?.data);
                await setIsLoading(false)
                await setHistory(res)
                await toggleDrawerTransact(anchor, true, mandate)({ type: "click" });
                // setShowSingleDebitModal(false)
                // setFaReport(res?.data)
            })
            .catch((err) => {
                setIsLoading(false)
                notify("danger", "OOPS", `${err?.response?.data?.message}`);
                console.log('err ', err);
            })
    }

    const handleCheckDownload = async () => {
        const params = {
            status: status,
            startDate: startDate,
            endDate: endDate
        }

        const searchParams = new URLSearchParams()
        // Add parameters only if they are defined and not empty
        Object.entries(params).forEach(([key, value]) => {
            if (value) {
                searchParams.append(key, value);
            }
        });
                setIsLoading(true)

        await checkExportTransactionHistoryOld(searchParams)
            .then(async (res) => {
                  console.log("transaction history res ", res);
                  if(res?.canExport == false){
                    notify("danger", "OOPS", `${res?.message}`);
                  }
                  if(res?.canExport){
                    await handleExportHistory()
                  }
                // setShowSingleDebitModal(false)
                // setFaReport(res?.data)
            })
            .catch((err) => {
                setIsLoading(false)
                notify("danger", "OOPS", `${err?.response?.data?.message}`);
                console.log('err ', err);
            })
                setIsLoading(false)
    }



    const handleFileChangeNew = (e) => {
        const file = e.target.files[0];
        setUploadedFile(file)

    };

    const handleUploadFileNew = async () => {
        setIsUploadFile(true);
        // console.log("uploaded file ", uploadedFile);

        const formData = new FormData()
        formData.append('file', uploadedFile)
        await batchUploadFileAllNewMandates(formData)
            .then(async (res) => {
                console.log("res ", res);

                if (res.message) {
                    // const storedPage = sessionStorage.getItem("currentPage");
                    // const initialPage = storedPage ? parseInt(storedPage, 10) : 1;
                    notify("success", "success", `${res?.message}. Created mandates: ${res?.data?.uploaded}. Duplicates: ${res?.data?.duplicates}`);
                    setIsUploadFile(false);
                    await handleAllMandates(1, 10)
                    // toggle();
                    // refetch(initialPage);
                } else {
                    notify("danger", "OOPS", "something went wrong");
                    setIsUploadFile(false);
                }
            })
            .catch((error) => {
                notify("danger", "OOPS", error?.response?.data?.message);
                setIsUploadFile(false);
            });
    };

    return (
        <>
            {loading ? (
                <div className="typewriter-container">
                    <div class="typewriter">
                        <div class="slide">
                            <i></i>
                        </div>
                        <div class="paper"></div>
                        <div class="keyboard"></div>
                    </div>
                    <code style={{ color: "#000" }}>Getting your app ready...</code>
                </div>
            ) : (
                <div style={{ overflowX: "auto" }}>
                    {/* <Row className="mb-3">
                        <Form.Group as={Col} controlId="formGridCity">
                            <Form.Label>Upload File</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type="file"
                                    placeholder="Upload excel file."
                                    name="excelFile"
                                    onChange={handleFileChangeNew}
                                />
                                <Button
                                    variant="outline-secondary"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleUploadFileNew();
                                    }}
                                    disabled={isUploadFile}
                                >
                                    {isUploadFile ? <FiRefreshCcw className="spin" /> : "Upload"}
                                </Button>
                            </InputGroup>
                        </Form.Group>
                    </Row> */}
                    <div style={{display: "flex", justifyContent: "space-between", margin: "10px 0px"}}>
                    <div style={{display: "flex"}}>
                        <div>
                            <p style={{fontSize: "14px", marginBottom: "5px"}}>Start date</p>
                            <input type="date" value={startDate} onChange={(e)=> setStartDate(e.target.value)} style={{border: "1px solid black", borderRadius: "5px", padding: "5px 10px", outline: "none"}} />
                        </div>
                        <div style={{marginLeft: "10px"}}>
                            <p style={{fontSize: "14px", marginBottom: "5px"}}>End date</p>
                            <input type="date" value={endDate} onChange={(e)=> setEndDate(e.target.value)} style={{border: "1px solid black", borderRadius: "5px", padding: "5px 10px", outline: "none"}} />
                        </div>
                    </div>

                    <div style={{display: "flex", alignItems: "flex-end"}}>
                    <form onSubmit={async (e) => {
                        e.preventDefault()
                        setIsLoading(true);
                        await handleAllMandates(1, 10)
                        setIsLoading(false);
                    }} style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                        <div>
                            <p style={{fontSize: "14px", marginBottom: "5px"}}>Status</p>
                        <select value={status} onChange={(e) => setStatus(e.target.value)} style={{ border: "1px solid black", borderRadius: "5px", padding: "5px 10px", outline: "none" }} >
                            <option value="">All</option>
                            <option value="success">Success</option>
                            <option value="failed">Failed</option>
                            </select>
                            </div>
                            <div style={{display: "flex", alignItems: "flex-end"}}>
                        <button type="submit" style={{ border: "none", backgroundColor: "#007dcc", color: "white", padding: "0px 10px", borderRadius: "5px", padding: "4px 10px", }}>Search</button>
                        </div>
                    </form>
                        <button type="button" onClick={handleCheckDownload} style={{ border: "none", backgroundColor: "#007dcc", color: "white", padding: "4px 10px", borderRadius: "5px", marginLeft: "10px" }}><GoDownload color="white" />Export</button>
                    </div>
                    </div>
                    {/* <h5 className='mt-3'>Sms Report</h5> */}
                    {allMandates?.length < 1 ? 
                    <div style={{display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh", flexDirection: "column"}}>
                                            <GoStop color="#007dcc" size={50} />
                                            <p style={{fontSize: '20px'}}>No Transaction History.</p>
                                        </div>
                    :
                    <>
                    <table className="fl-table">
                        <thead>
                            <tr style={{ borderBottom: "0.5px solid #f1f1f1" }}>
                                {/* Table header cells */}
                                {/* Modify according to your data structure */}
                                <th width="20%">Mandate Code</th>
                                <th width="20%">Subscriber Code</th>
                                <th>Amount</th>
                                <th>Account number</th>
                                <th>Account Name</th>
                                <th>Payment reference</th>
                                <th>Response</th>
                                <th>Created At</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                allMandates?.map((mandate) => (
                                    <tr
                                        className="tr"
                                        key={mandate.id}
                                    >
                                        <td className="gray-td">{mandate?.mandateCode}</td>
                                        <td className="gray-td">{mandate?.subscriberCode}</td>
                                        <td className="gray-td">{Number(mandate?.amount).toLocaleString()}</td>
                                        <td className="gray-td">{mandate?.originatorAccountNumber}</td>
                                        <td className="gray-td">{mandate?.originatorAccountName}</td>
                                        <td className="gray-td">{mandate?.paymentReference}</td>

                                        <td className="gray-td">{mandate?.errorMessage} {mandate?.errorCode && `(${mandate?.errorCode})`}</td>
                                        <td className="gray-td">{moment(mandate?.createdAt).format('DD MMM, YYYY')}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                    <ReactPaginate
                        previousLabel={"Prev"}
                        nextLabel={"Next"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={pageCount} // Total pages from API
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        forcePage={currentPage - 1}
                    />
                    </>}
                    <LoadingModal show={isLoading} />
                    <ModalSingleDebit 
                    show={showSingleDebitModal} 
                    toggle={() => setShowSingleDebitModal(!showSingleDebitModal)} 
                    handleUpdateResumptionDate={handleSingleDebit} 
                    isUpdating={loadDebitting} 
                    mandateInfo={mandateInfo}
                    resumption={resumption}
                    setIsResumption={setIsResumption}
                    note={note}
                    setNote={setNote} 
                    handleTransaction={handleTransaction}
                    />
                </div>
            )}
        </>
    )
}

export default TransactionHistoryOld